<div class="placing-item" (click)="closeDialog()">
  <div class="container-modal">
    <div class="container-video">
      <div class="title">
        <div class="name">{{ videoInfo.title }}</div>
        <button class="sound-button" *ngIf="isPlayerReady && player" (click)="changeSound($event)">
          <img *ngIf="!player.muted()" src="assets/images/new-design-icons/sound.svg">
          <img *ngIf="player.muted()" src="assets/images/new-design-icons/sound-off.svg">
        </button>
      </div>
      <video
      #videoPlayer
      class="video"
      [id]="videoId"
      [poster]="videoThumbnail"
      playsinline
      loop
      [controls]="false"
    >
    </video>
    <button class="pause-btn" *ngIf="isPlayerReady && player && player.paused()" (click)="handleVideo($event)">
      <img class="play" src="assets/images/new-design-icons/play-video.svg" alt="play" />
    </button>
    </div>
  
    <div class="close">
      <app-button
              [buttonClass]="'only-icon-light-gray'"
              [iconDirection]="'left'"
              [icon]="'assets/images/new-design-icons/close-white.svg'"
              (buttonClick)="closeDialog()"/>
    </div>
  </div>
</div>